import classNames from 'classnames';
import { ForwardedRef, ReactElement, forwardRef } from 'react';

import QuotesIcon from '~images/inline/quotes.svg';

import * as styles from './Card.module.css';

const ReviewCard = forwardRef(
    (
        { children, index }: { children: ReactElement; index?: number },
        ref: ForwardedRef<HTMLDivElement | null>
    ) => (
        <div
            className={classNames(
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
                styles.reviewCard,
                'review-card',
                'bg-white border border-solid border-gray-outline rounded-lg shadow-md',
                'min-w-72 md:min-w-[336px] lg:max-w-[588px] w-full',
                'h-full min-h-[328px] md:min-h-[352px] lg:min-h-72 px-1 py-6 lg:p-8',
                'gap-4 flex flex-col items-start justify-between relative'
            )}
            ref={ref}
            data-index={index}
        >
            <img
                src={QuotesIcon}
                alt="quote"
                aria-hidden="true"
                className="absolute top-6 left-1 lg:left-8"
            />
            {children}
            <img
                src={QuotesIcon}
                alt="quote"
                aria-hidden="true"
                className="absolute mt-auto rotate-180 bottom-20 right-1 lg:right-8"
            />
        </div>
    )
);

ReviewCard.displayName = 'ReviewCard';

export default ReviewCard;
